<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top navbar-default">
    <a class="navbar-brand" href="https://www.csub.edu">
      <img src="../assets/images/CSUB_Logo.png" height="70" class="d-inline-block align-top" alt="CSUB Logo">
    </a>
    <button id="navBtn" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="moreAccessDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            More Access
          </a>
          <ul class="dropdown-menu" aria-labelledby="moreAccessDropdown">
            <li v-for="link in moreAccess" :key="link.id"><a target="_blank" :title="link.name" :href="link.loc" v-html="link.name" class="dropdown-item"></a></li>
          </ul>
        </li>

        <li class="nav-item">
          <a class="nav-link" href="https://my.csub.edu">myCSUB</a>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="needHelpDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Need Help?
          </a>
          <ul class="dropdown-menu" aria-labelledby="needHelpDropdown">
            <li v-for="link in needHelp" :key="link.id">
              <a target="_blank" :title="link.name" :href="link.loc" v-html="link.name" class="dropdown-item"></a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'navigation',
  data () {
    return {
      moreAccess: [
        {
          name: 'O365 Email &amp; Calendar',
          loc: 'https://o365.csub.edu'
        },
        {
          name: 'Canvas',
          loc: 'https://canvas.csub.edu'
        },
        {
          name: 'Faculty &amp; Staff',
          loc: 'https://www.csub.edu/faculty-and-staff'
        }
      ],
      needHelp: [
        {
          name: 'Find my Net ID',
          loc: 'https://www.csub.edu/lookup'
        },
        {
          name: 'Manage Password',
          loc: 'https://netid.csub.edu/accounts/'
        },
        // {
        //   name: 'Change Password',
        //   loc: 'https://csub.edu/accounts/?endpoint=password'
        // },
        // {
        //   name: 'Password Reset',
        //   loc: 'https://csub.edu/accounts/?endpoint=password/reset'
        // },
        {
          name: 'Account Disabled?',
          loc: 'https://www.csub.edu/myid/'
        },
        {
          name: 'New to the Campus?',
          loc: 'https://csub.service-now.com/sp?id=sc_category&sys_id=8a2ff3cd6fac2100ad775ddd5d3ee4d8'
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .navbar-default {
    background: #24C6DC; /* fallback for old browsers */
    background: -webkit-linear-gradient(to left, rgba(0, 53, 148, 1), rgba(0, 26, 112, 1) ); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to left,  rgba(0, 53, 148, 1), rgba(0, 26, 112, 1) ); /*W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    font-family: 'Oswald', sans-serif;
    border-bottom: 3px solid #ffd200;
    padding: 10px;
  }

  .navbar-default .navbar-nav > li > a {
    font-family: 'Oswald', sans-serif;
    font-size: 20px;
    /* font-weight: bold; */
    color: white !important;
    padding-top: 15px;
    margin-top: 15px;
  }

  .navbar-default .navbar-nav > li > a:hover {
    background: rgba(255, 199, 44, 1) !important;
    font-size: 20px;
    color: #000 !important;
  }

  .navbar-default .navbar-header > a {
    font-family: 'Alegreya', serif;
    color: rgba(255, 199, 44, 1);
    font-size: 28px;
    margin-top: 0px !important;
    padding-top: 10px !important;
    height: 90px;
  }

  .navbar-default .navbar-header > a:hover, .navbar-default .navbar-header .active > a:hover {
    font-family: 'Alegreya', serif;
    color: rgba(255, 199, 44, 1);
    font-size: 28px;
  }

  .navbar-default .navbar-nav > .open > a, .navbar-default .navbar-nav > .open > a:focus, .navbar-default .navbar-nav > .open > a:hover {
    background-color: rgba(255, 199, 44, 1) !important;
  }

  .dropdown-menu {
    background: white !important;
  }

  .dropdown-menu > li:hover {
    background: rgba(255, 210, 0, 0.25) !important;
  }

  .dropdown-menu > div > li > a {
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143;
    color: #333;
    white-space: nowrap;
  }

  .dropdown-menu > div > li > a {
    color: #0b6dac !important;
    background: white !important;
  }

  .dropdown-menu > li > a:hover {
    background-color: transparent !important;
  }

  #navBtn {
    background-color: rgba(251, 251, 251, 0.95);
    color: black;
  }
</style>
